module.exports = __webpack_public_path__ + "img/ARA.30917e70.png";